window.custom_acc_key_mouse = function(){
    var $keypass = jQuery.noConflict();

        $keypass( "#accordion li" ).attr( "data-time", "00" );
        var cur_time_old = "00";
        /******************code for time capture starts here**************/
        function time_capture(attr_pass_que)
        {
            var cur_time = $keypass("#stopwatch").html();    /****getting current time *****/
            var attr_time = $keypass( "#accordion li#qu"+attr_pass_que ).attr( "data-time" );     /****getting current attr data-time *****/
            var cur_time_s1 = cur_time.substr(0, 2);    /****getting current time min part *****/
                cur_time_s1 = cur_time_s1 * 60;         /****getting current time min part converted into seconds*****/
            var cur_time_s2 = cur_time.substr(3, 2);    /****getting current time second part*****/
            var cur_time_total =  cur_time_s1 + parseInt(cur_time_s2);
            var cur_time_new = cur_time_total - cur_time_old;        
            var ori_cur_time = parseInt(cur_time_new) + parseInt(attr_time);
            $keypass("#t"+attr_pass_que).html(ori_cur_time);
            $keypass( "#accordion li#qu"+attr_pass_que ).attr( "data-time", ori_cur_time );
            $keypass("#ans-time-"+attr_pass_que).attr("value", ori_cur_time)
            cur_time_old = cur_time_total;
        }
        /******************code for time capture ends here**************/
        function accordion_slide_next()
        {
            var last_pass_id = $keypass('#accordion li:last-child').attr( "pass_que" );
            var pass_qu_id = $keypass( "li.open" ).attr( "pass_que" );
            var pass_qu_id_new = parseInt(pass_qu_id) + 1;
            if(last_pass_id == pass_qu_id)
            {
                // do nothing
            }
            else
            {
                $keypass('li#qu'+pass_qu_id).removeClass("open");
                $keypass('li#qu'+pass_qu_id+' .submenu').slideUp( "slow" );
                $keypass('li#qu'+pass_qu_id_new).addClass("open");
                $keypass('li#qu'+pass_qu_id_new+' .submenu').slideDown( "slow" );
            }
            time_capture(pass_qu_id);
        }
            $keypass('#accordion input:radio').click(function(){
                accordion_slide_next();
            });
        $keypass(document).keydown(function(e){
            if($keypass( "#open-block1" ).hasClass( "fade-block" ))
            {
               return false;
            }
            /**************** code for alhapbets key ***************/
            if (( e.keyCode >= 65 ) && ( e.keyCode <= 69 )) {
                if(e.keyCode == 65)
                {
                    if($keypass("#accordion li.open input.a").prop("checked"))
                    {
                        $keypass("#accordion li.open input.a").prop("checked", false);
                    }
                    else
                    {
                        $keypass("#accordion li.open input.a").prop("checked", true);
                    }
                    accordion_slide_next();
                }
                if(e.keyCode == 66)
                {
                    if($keypass("#accordion li.open input.b").prop("checked"))
                    {
                        $keypass("#accordion li.open input.b").prop("checked", false);
                    }
                    else
                    {
                        $keypass("#accordion li.open input.b").prop("checked", true);
                    }
                    accordion_slide_next();
                }
                if(e.keyCode == 67)
                {
                    if($keypass("#accordion li.open input.c").prop("checked"))
                    {
                        $keypass("#accordion li.open input.c").prop("checked", false);
                    }
                    else
                    {
                        $keypass("#accordion li.open input.c").prop("checked", true);
                    }
                    accordion_slide_next();
                }
                if(e.keyCode == 68)
                {
                    if($keypass("#accordion li.open input.d").prop("checked"))
                    {
                        $keypass("#accordion li.open input.d").prop("checked", false);
                    }
                    else
                    {
                        $keypass("#accordion li.open input.d").prop("checked", true);
                    }
                    accordion_slide_next();
                }
                if(e.keyCode == 69)
                {
                    if($keypass("#accordion li.open input.e").prop("checked"))
                    {
                        $keypass("#accordion li.open input.e").prop("checked", false);
                    }
                    else
                    {
                        $keypass("#accordion li.open input.e").prop("checked", true);
                    }
                    accordion_slide_next();
                }
            }
        });
    }